<script>
export default {
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
  },
};
</script>

<template>
  <!-- Phase 9.6: the title and introduction of a new-inbox step, in the kit's type (section title, muted body). -->
  <div class="mb-4 flex w-full flex-col items-start gap-1.5">
    <h2 class="break-words type-polaris-section-title text-polaris-foreground">
      {{ headerTitle }}
    </h2>
    <p
      v-dompurify-html="headerContent"
      class="w-full max-w-3xl type-polaris-body text-polaris-muted-foreground"
    />
  </div>
</template>
